<template>
    <div class="container">
        <van-nav-bar title="新增施工项目" left-text="" right-text="保存" left-arrow @click-left="onClickLeft"
            @click-right="onClickRight">
        </van-nav-bar>

        <div class="menu">
            <van-field readonly clickable label="选择城市" :value="cityName" placeholder="请选择" @click="showPicker" />
            <van-field readonly clickable label="选择项目" :value="communityName" placeholder="请选择" @click="showPicker2" />
        </div>

        <van-popup v-model="showPopup" round position="bottom">
            <van-picker show-toolbar :columns="cityList" value-key="name" @cancel="showPopup = false"
                @confirm="onConfirm" />
        </van-popup>
        <van-popup v-model="showPopup2" round position="bottom">
            <van-picker show-toolbar :columns="communityList" value-key="communityName" @cancel="showPopup2 = false"
                @confirm="onConfirm2" />
        </van-popup>
    </div>
</template>
  
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, } from 'vant';
export default {
    data() {
        return {
            communityId: undefined,
            communityName: '',
            cityName: "",
            cityCode: '',

            showPopup: false,
            showPopup2: false,

            cityList: [],
            communityList: [],
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [List.name]: List
    },
    methods: {
        getCityList() {
            axios.get("/common/getcitylist?proviceId=410000").then((res) => {
                this.cityList = res.data;
                this.cityList && this.cityList.forEach(item => {
                    item.children = null;
                })
            })
        },
        getCommunityList(picker) {
            axios.post("/common/getcommunitylistbycitycode", {
                cityCode: this.cityCode,
            }).then((res) => {
                if (res.data.length > 0) {
                    res.data.forEach(item => {
                        item.name = item.communityName
                        item.id = item.communityId
                    })
                }
                this.communityList = res.data;
                if (picker) {
                    picker.setColumnValues(1, res.data);
                }

            })
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        onClickRight() {
            if (!this.cityCode) {
                Toast('请选择城市');
                return;
            } else if (!this.communityId) {
                Toast('请选择项目');
                return;
            } else {
                axios.post("/constructioncommunity/create", {
                    communityId: this.communityId,
                    status: 0,
                }).then((res) => { 
                    if(res.isSuccess){
                        Toast('创建成功');
                        this.$router.replace({ path: "constructionList.html" });
                    }
                });

            }
        },

        //选择城市
        showPicker() {
            this.showPopup = true;
        },
        onConfirm(item) {
            this.cityName = item.name;
            this.cityCode = item.id;
            this.showPopup = false;
            this.getCommunityList();
        },

        showPicker2() {
            if (!this.cityCode) {
                Toast('请选择城市');
                return;
            }
            this.showPopup2 = true;
        },

        onConfirm2(item) {
            this.communityName = item.communityName;
            this.communityId = item.id;
            this.showPopup2 = false;
        },
    },
    computed: {
    },
    created() {
        this.getCityList();
    },
    mounted() { },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F0F4F7
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F0F4F7;
}

.list-box {
    width: 100%;
    color: #373737;

    .list {
        font-size: 14px;
        width: 100%;
        background: #fff;
        margin: 12px 0;
        padding: 12px;

        .fl_right {
            text-align: right;
            margin-top: 15px;

            img {
                width: 6px;
                margin-left: 8px;
                margin-bottom: 2px;
                vertical-align: middle;
            }
        }
    }

    .mg10 {
        margin-bottom: 10px;
    }

    .bold {
        font-weight: bold;
    }
}

.menu {
    width: 100%;
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fff;

    .menuitem {
        width: 50%;
        display: inline-block;

        .icon {
            width: 10px;
            height: 6px;
            vertical-align: middle;
        }
    }
}
</style>
  